module.exports = __webpack_public_path__ + "media/Video 11.5fec8421.mp4";